export enum PaymentState {
    Indeterminado = 'Indeterminado',
    IntencionPagoSolicitado = 'IntencionPagoSolicitado',
    IntencionPagoConfirmado = 'IntencionPagoConfirmado',
    IntencionPagoConError = 'IntencionPagoConError',
    PagoEfectuadoConExito = 'PagoEfectuadoConExito',
    PagoEfectuadoCancelado = 'PagoEfectuadoCancelado',
}